import {useAddress, useRoute} from '@yandex-taxi/react-integration-api'
import {createContext, useContext} from 'react'

import {MapBoundsContext as Context} from './types'

export const MapBoundsContext = createContext<Context | null>(null)

const useMapBoundsContext = (): Context => {
  const contextValue = useContext(MapBoundsContext)

  if (contextValue === null) {
    throw new Error('context "MapBoundsContext" not found')
  }

  return contextValue
}

export const useInputAddress: typeof useAddress = index => {
  const [, setSettings] = useMapBoundsContext()
  const [field, helpers] = useAddress(index)

  return [
    field,
    {
      ...helpers,
      setValue(value) {
        helpers.setValue(value)

        setSettings({shouldBounds: true})
      },
    },
  ]
}

export const useMapRoute: typeof useRoute = () => {
  const [{shouldBounds}, setSettings] = useMapBoundsContext()
  const [field, helpers] = useRoute()

  return [
    field,
    {
      ...helpers,
      remove(index) {
        if (shouldBounds === false) {
          setSettings({shouldBounds: true})
        }

        helpers.remove(index)
      },
      clear(index) {
        if (shouldBounds === false) {
          setSettings({shouldBounds: true})
        }

        helpers.clear(index)
      },
    },
  ]
}

export const useMapAddress: typeof useAddress = index => {
  const [{shouldBounds}, setSettings] = useMapBoundsContext()
  const [field, helpers] = useAddress(index)

  return [
    field,
    {
      ...helpers,
      setValue(value) {
        if (shouldBounds === true) {
          setSettings({shouldBounds: false})
        }

        helpers.setValue(value)
      },
    },
  ]
}

export const useShouldBoundsSettings = () => useMapBoundsContext()[0].shouldBounds

export const useSetBoundsSettings = () => useMapBoundsContext()[1]
